<template>
  <div>
    <filter-wide-events ref="FilterWideEvents" />
    <show-wide-events />
  </div>
</template>

<script>
export default {
  components: {
    FilterWideEvents: () => import('./components/FilterWideEvents'),
    ShowWideEvents: () => import('./components/ShowWideEvents'),
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // Limpiar resultados excepto cuando se regresa del detalle
      if (from.name !== 'wideEventDetail') {
        vm.$store.commit('wideEvents/setSearchResults', null)
      }
    })
  },
}
</script>
